<template>
    <div>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white">
                Check Out - Basket
            </h1>
        </div>
        <div class="grid-container pad-top">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-8">
                    <div v-if="basket.length === 0">
                        <p class="lead">
                            Please add at least one garment to your basket before checking out.
                        </p>
                        <p>If you would like any help please contact us on <a href="tel:441164670260">+44 (0)116 467 0260</a></p>
                        <p><router-link to="/garments/all" class="button">Browse garments</router-link></p>
                    </div>
                    <div
                        v-for="(item, index) in basket"
                        v-bind:key="index"
                        class="bordered light shadowed marg-bottom--small">
                        <div class="grid-x">
                            <div class="cell small-12 medium-3">
                                <div class="pad">
                                    <app-preview-design v-if="item.design_id" v-bind:itemNo="index" v-bind:designId="item.design_id" />    
                                    <img
                                        v-else
                                        v-bind:src="`https://our-catalogue.com/RUNS/images/${item.product_code}.jpg?width=100`"
                                        alt="" />
                                </div>
                            </div>
                            <div class="cell small-12 medium-9">
                                <div class="grid-x grid-padding-x pad-top">
                                    <div class="cell small-12 medium-8">
                                        <h5>{{ item.product_code }} | {{ item.name }} | {{ item.colour }}</h5>
                                    </div>
                                    <div class="cell small-10 medium-3">
                                        <p>
                                            &pound;{{ item.price | numeral('0,0.00') }}*{{ item.quantity }}<br />
                                            VAT: &pound;{{ item.vat | numeral('0,0.00') }}*{{ item.quantity }}
                                        </p>
                                    </div>
                                    <div class="cell small-2 medium-1">
                                        <i
                                            v-on:click="removeFromBasket(item.basket_item_id)"
                                            class="material-icons text-red link">delete</i>
                                    </div>
                                </div>
                                <div class="grid-x grid-padding-x pad-top">
                                    <div class="cell small-12 medium-3">
                                        <p class="small">
                                            <span class="text-light">Product Colour</span><br />
                                            <span v-bind:style="{backgroundColor : '#' + item.hex}" class="colour-disk small nudge-down"></span>
                                            <span class="text-heavy">{{ item.colour }}</span>
                                        </p>
                                    </div>
                                    <div class="cell small-12 medium-3">
                                        <p class="small">
                                            <span class="text-light">Size</span><br />
                                            <span
                                                v-for="(size, index) in item.size"
                                                v-bind:key="index"
                                                class="text-heavy">{{ size }}<br /></span>
                                        </p>
                                    </div>
                                    <div class="cell small-12 medium-2">
                                        <span class="text-light">Method</span><br />
                                        <span class="text-capitalize text-heavy">{{ item.method | methodText }}</span>
                                    </div>
                                    <div class="cell small-12 medium-4">
                                        <p class="small text-right pad-right--small">
                                            <span class="text-light">Customise</span><br />
                                            <span
                                                v-if="item.design_name"
                                                class="text-heavy">{{ item.design_name }}</span>
                                            <span
                                                v-else
                                                class="text-heavy">Design {{ item.design_id }}</span>
                                            <br />
                                            <span v-for="(info, index) in item.design_info" v-bind:key="index">
                                                <span>Side: {{ info.side }}</span><br />
                                                <span>Method: {{ info.method }}</span><br />
                                                <span>Price: &pound;{{ (info.cost / 100) | numeral('0,0.00') }}</span><br />
                                            </span>
                                            <span>Price &pound;{{ (item.design_price /100) | numeral('0,0.00') }}*{{ item.quantity }}</span><br />
                                            <span>VAT &pound;{{ (item.design_vat / 100) | numeral('0,0.00') }}*{{ item.quantity }}</span><br />
                                            <router-link
                                                v-if="item.design_id"
                                                v-bind:to="`/preview/${item.design_id}`">
                                                Preview design
                                            </router-link>
                                        </p>
                                    </div>
                                </div>
                                <div class="grid-x grid-padding-x pad-top pad-bottom">
                                    <div class="cell small-12 medium-8">
                                        Quantity:&nbsp;
                                        <input
                                            style="width:40%"
                                            v-bind:value="item.quantity"
                                            v-on:keyup="updateQuantity"
                                            v-bind:data-item="item.id"
                                            type="number" />
                                    </div>
                                    <div class="cell small-12 medium-4">
                                        <p class="text-heavy pad-top--large">
                                            <img
                                                class="nudge-up"
                                                src="../../../static/images/icons/clock.png"
                                                alt="" />&nbsp;
                                            <span v-if="delivery === 1">5 days delivery</span>
                                            <span v-else>2 days delivery</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cell small-12 medium-4">
                    <div class="bordered light shadowed pad">
                        <div class="cart-progress">
                            <span class="one active"></span>
                            <span class="two"></span>
                            <span class="three"></span>
                        </div>
                        <h5 class="text-right pad-top">Summary</h5>
                        <hr />
                        <ul>
                            <li
                                v-for="(item, index) in basket"
                                v-bind:key="index"
                                class="">
                                {{ item.product_code }} {{ item.colour }}
                                <span class="float-right">
                                    &pound;{{ ((item.price + ( item.design_price / 100 )) * item.quantity ) | numeral('0,0.00') }}
                                </span>
                            </li>
                        </ul>
                        <table class="fixed">
                            <tbody>
                                <tr>
                                    <th>SubTotal</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ basketSubTotal | numeral('0,0.00') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>VAT</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ basketVatTotal | numeral('0,0.00') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Total</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ (deliveryPrice + basketSubTotal + basketVatTotal) | numeral('0,0.00') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="text-center text-blue pad-top">
                            <router-link to="/garments/all">Continue shopping</router-link>
                            <hr />
                        </p>
                        <button
                            v-on:click="addAddresses"
                            class="button tall green expanded">Proceed To Check Out
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import previewDesign from '@/components/Order/PreviewSingle';
import axios from '../../axios';

export default {
    name: 'Basket',
    components: {
        appPreviewDesign: previewDesign,
    },
    computed: {
        basket() {
            return this.$store.getters.basketItems;
        },
        basketSubTotal() {
            return this.$store.getters.basketSubTotal;
        },
        basketVatTotal() {
            return this.$store.getters.basketVatTotal;
        },
        delivery: {
            get() {
                return this.$store.getters.delivery;
            },
            set(value) {
                this.$store.dispatch('updateDelivery', value);
            },
        },
        deliveryPrice() {
            return this.$store.getters.deliveryPrice;
        },
    },
    methods: {
        addAddresses() {
            const totalPrice = (this.deliveryPrice + this.basketSubTotal + this.basketVatTotal);
            this.$store.dispatch('setTotal', totalPrice);
            this.$router.push('/checkout/addresses');
        },
        checkBasket() {
            this.$store.dispatch('checkBasket');
        },
        updateQuantity(event) {
            const element = event.currentTarget;
            const postData = {};
            postData.item = element.getAttribute('data-item');
            postData.quantity = element.value;
            setTimeout(() => {
                axios.post('/Baskets/updateQuantity.json', postData).then(() => {
                    this.checkBasket();
                });
            }, 800);
        },
        removeFromBasket(item) {
            this.$store.dispatch('removeFromBasket', item);
        },
    },
    filters: {
        methodText(value) {
            if (!value) return '';
            let newValue = value.replace('printedText', 'Printed text');
            newValue = value.replace('embroideredText', 'Embroidered text');
            return newValue;
        },
    },
    mounted() {
        this.checkBasket();
    },
};
</script>


// WEBPACK FOOTER //
// src/components/CheckOut/Basket.vue